import { getAnonymousUserId } from './anonymousUserId'
import browserEnv from './env/browserEnv'

let user_id: number | undefined = undefined
export const setUserId = (id?: number) => (user_id = id)
export const getClientId = () => {
  const match = document.cookie.match(/_ga=(.+?)(;|$)/)

  if (match) {
    return match[1].split('.').slice(-2).join('.')
  }
  return undefined
}

type UserType =
  | 'notLogin'
  | 'free'
  | 'trial'
  | 'trialCancel'
  | 'paying'
  | 'payingCancel'
  | 'canceled'
let user_type: UserType = 'notLogin'
export const setUserType = (type: UserType) => (user_type = type)

export const sendEvent = (params: {
  event: string
  screen: string
  category: string
  action: string
  label?: string
  value?: string
  currency?: string
  coupon?: string
}) => {
  const anonymousUserId = getAnonymousUserId()

  if (browserEnv.NEXT_PUBLIC_GTM_ENABLED) {
    window?.dataLayer?.push({ ...params, user_id, user_type, anonymous_user_id: anonymousUserId })
  }
  if (browserEnv.NEXT_PUBLIC_ENV === 'development') {
    console.log('GA Event:', params)
  }
}

export const sendLog = (params: { screen: string; action: string; value?: string }) => {
  const anonymousUserId = getAnonymousUserId()

  const logParams = {
    event: 'web_action',
    category: 'event',
    anonymous_user_id: anonymousUserId,
  }

  if (browserEnv.NEXT_PUBLIC_GTM_ENABLED) {
    window?.dataLayer?.push({ ...params, ...logParams, user_id, user_type })
  }
  if (browserEnv.NEXT_PUBLIC_ENV === 'development') {
    console.log('GA Web Action:', params)
  }
}
